/**
 * Sorts Unbxd Browse/Search brand facet values A–Z after each facet render.
 * Hooks facet.onFacetLoad (see Netcore Unbxd JS SDK — Callback Functions / onFacetLoad).
 */
(function () {
  'use strict';

  var BRAND_TITLE_RE = /^brands?$/i;
  var BRAND_FIELD_RE = /brand|vendor/i;

  function isBrandFacetWrap(wrap) {
    var header = wrap.querySelector('.UNX-facet-header[data-facet-name]');
    var h3 = wrap.querySelector('.UNX-facet-header h3');
    var facetName = header ? header.getAttribute('data-facet-name') || '' : '';
    var title = h3 ? h3.textContent.trim() : '';
    if (BRAND_FIELD_RE.test(facetName)) return true;
    if (BRAND_TITLE_RE.test(title)) return true;
    return false;
  }

  function sortBrandFacetInWrap(wrap) {
    var facetsContainer = wrap.querySelector('.UNX-facets');
    if (!facetsContainer) return;

    var items = Array.prototype.slice.call(
      facetsContainer.querySelectorAll('button.UNX-change-facet')
    );
    if (items.length < 2) return;

    items.sort(function (a, b) {
      var ta = (a.querySelector('.UNX-facet-text') || {}).textContent || '';
      var tb = (b.querySelector('.UNX-facet-text') || {}).textContent || '';
      ta = ta.trim();
      tb = tb.trim();
      return ta.localeCompare(tb, undefined, { sensitivity: 'base' });
    });

    for (var i = 0; i < items.length; i++) {
      facetsContainer.appendChild(items[i]);
    }
  }

  function sortAllBrandFacets() {
    var root = document.querySelector('.unbxd-filter-wrapper');
    if (!root) return;
    var wraps = root.querySelectorAll('.UNX-text-facet-wrap');
    for (var i = 0; i < wraps.length; i++) {
      if (isBrandFacetWrap(wraps[i])) sortBrandFacetInWrap(wraps[i]);
    }
  }

  function patchOnFacetLoad() {
    var search = window.unbxdSearch;
    if (!search || !search.options || !search.options.facet) return false;

    var facet = search.options.facet;
    if (facet.__fairwayBrandFacetSortPatched) return true;

    var original = facet.onFacetLoad;
    facet.onFacetLoad = function () {
      try {
        if (typeof original === 'function') {
          original.apply(this, arguments);
        }
      } finally {
        sortAllBrandFacets();
      }
    };
    facet.__fairwayBrandFacetSortPatched = true;
    return true;
  }

  function waitAndPatch() {
    var attempts = 0;
    var max = 200;

    function tick() {
      if (patchOnFacetLoad()) return;
      attempts += 1;
      if (attempts < max) requestAnimationFrame(tick);
    }

    tick();
  }

  document.addEventListener(
    'click',
    function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      var btn = t.closest('.js-show-more[data-action="viewMore"]');
      if (!btn) return;
      var root = document.querySelector('.unbxd-filter-wrapper');
      if (!root || !root.contains(btn)) return;
      var wrap = btn.closest('.UNX-text-facet-wrap');
      if (!wrap || !isBrandFacetWrap(wrap)) return;
      window.setTimeout(function () {
        sortBrandFacetInWrap(wrap);
      }, 0);
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waitAndPatch);
  } else {
    waitAndPatch();
  }
})();
